export default "__VITE_ASSET__kKbmIN6K__"